import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
import { pascalCase } from 'change-case';

const state = {
  realtime: [],
  analstatic: [],
  // Added.by.KWShin.2026.01.06.
  extraordinaries: [],
  preference: [],
  // Added.by.KWShin.2026.07.20.
  allowedMenuIds: [],
};

const getters = {};

const mutations = {
  setRealtime(state, realtime) {
    state.realtime = realtime;
  },
  setAnalstatic(state, analstatic) {
    state.analstatic = analstatic;
  },
  // BEGIN::Added.by.KWShin.2026.01.06.
  setExtraordinaries(state, extraordinaries) {
    state.extraordinaries = extraordinaries;
  },
  // FINISH::Added.by.KWShin.2026.01.06.
  setPreference(state, preference) {
    state.preference = preference;
  },
  // BEGIN::Added.by.KWShin.2026.07.20.
  setAllowedMenuIds(state, allowedMenuIds) {
    state.allowedMenuIds = allowedMenuIds;
  },
  // FINISH::Added.by.KWShin.2026.07.20.
  // 로그아웃 시 호출. 다음 로그인 사용자의 메뉴가 옛 데이터로 잘못 표시되는 것 방지.
  reset(state) {
    state.realtime = [];
    state.analstatic = [];
    state.extraordinaries = [];
    state.preference = [];
    state.allowedMenuIds = [];
  },
};

const actions = {
  async fetchMenus({ commit, dispatch, rootState }) {
    const { data } = await api.get('/menus');
    data.items
      .map(item => item.name)
      .forEach(name => {
        commit(
          `set${pascalCase(name)}`,
          data.items.filter(item => item.name == name),
        );
      });
    // BEGIN::Added.by.KWShin.2026.07.10.
    // CONF_USER_MTL에서 사용자에게 접근이 허용된 메뉴의 ID 목록을 읽어온다.
    // BEGIN::Modified.by.KWShin.2026.09.10.
    // 메뉴접근권한 조회는 username을 URL 경로에 담아 보내는데,
    // fetchUser()가 끝나기 전에 이 액션이 불리면 username이 빈 문자열이어서
    // '/prefer/users//menu-auth'로 요청이 나가고 서버가 500(MissingPathVariableException)을 낸다.
    // 호출 순서에 의존하지 않도록 여기서 사용자 정보를 직접 채워 넣는다.
    if (isEmpty(rootState.common.user.username)) {
      await dispatch('common/user/fetchUser', null, { root: true });
    }
    if (isEmpty(rootState.common.user.username)) {
      // 그래도 사용자를 알 수 없으면 요청을 보내지 않는다.
      // 이 때 allowedMenuIds를 비우면 '권한설정 없음 = 전체 허용'으로 해석되어
      // 메뉴 접근제어가 조용히 풀려버리므로, 기존 값을 그대로 유지한다.
      return;
    }
    // FINISH::Modified.by.KWShin.2026.09.10.
    // eslint-disable-next-line prettier/prettier
    const { data: { authData}} = await api.get(`/prefer/users/${rootState.common.user.username}/menu-auth`);
    if (isEmpty(authData)) {
      commit('setAllowedMenuIds', []);
    } else {
      commit('setAllowedMenuIds', authData.split(','));
    }
    // FINISH::Added.by.KWShin.2026.07.10.
  },
  setRealtime({ commit }, realtime) {
    commit('setRealtime', realtime);
  },
  setAnalstatic({ commit }, analstatic) {
    commit('setAnalstatic', analstatic);
  },
  // BEGIN::Added.by.KWShin.2026.01.06.
  setExtraordinaries({ commit }, extraordinaries) {
    commit('setExtraordinaries', extraordinaries);
  },
  // FINISH::Added.by.KWShin.2026.01.06.
  setPreference({ commit }, preference) {
    commit('setPreference', preference);
  },
  // BEGIN::Added.by.KWShin.2026.07.20.
  setAllowedMenuIds({ commit }, allowedMenuIds) {
    commit('setAllowedMenuIds', allowedMenuIds);
  },
  // FINISH::Added.by.KWShin.2026.07.20.
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
